import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AtInternetService } from 'src/app/services/at-internet.service';
import { DeliveryChoiceService } from 'src/app/services/delivery-choice.service';
import { DeliveryDialogComponent } from '../../delivery-choice/delivery-dialog/delivery-dialog.component';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  pickedDate: string;
  isDatePicked: boolean = false;
  isEmailValid: boolean = false;
  confirmAction: boolean = false;
  choiceConfirmed: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<HomeComponent>,
    public homeConfirmationDialogRef: MatDialog,
    private deliveryChoiceService: DeliveryChoiceService,
    private atIternetService: AtInternetService) { }

    ngOnInit(){
    //on ne peut pas appeler le AtInternetService.generatePage()
    // à cause de la clef :"choix_livraison"
      this.data.tag.setProps({
        page : 'reprogrammation_domicile',
        choix_livraison: 'domicile'
      }, true);
      this.data.tag.page.set({
        name: 'reprogrammation_domicile'
      });                
      this.data.tag.dispatch();
    }
  //fermer la popin
  onNoClick(): void {
    this.dialogRef.close();
  }

  //fonction pour controller qu'une date est bien choisie
  validateDate(oneDate) {
    this.pickedDate = oneDate;
    //boolean pour changer la couleur au choix d'une date 
    this.isDatePicked = true;
  }

  saveChoices(): void {
    this.atIternetService.generatePage(
      this.data.tag, 
      'reprogrammation_domicile_recapitulation', 
      'reprogrammation_domicile_recapitulation'
    ); 
    this.confirmAction = true;
  }

  checkEmail(isValid: boolean) {
    this.isEmailValid = isValid;
  }

  modifyChoiceDate() {
    this.dialog.open(DeliveryDialogComponent, { disableClose: true, panelClass: 'delivery-choice-dialog', data: { "deliveryChoiceResponse": this.data.deliveryChoiceResponse, "tag": this.data.tag, "shortCode1": this.data.shortCode1, "shortCode2": this.data.shortCode2, "isModify":true } });
    this.onNoClick();
  }

  //pour retourner à l'état précédant et refill les champs du formulaire
  modifyChoiceConfirm = (): void => {
    this.atIternetService.generateClickAction(
      this.data.tag, 
      'modifier',
      'popin_modification_confirmation_adresse_reprogrammer_livraison'
    );
    this.confirmAction = false;
  }

  validateChoice= (email: string): void => {
    this.deliveryChoiceService.validateChoice(
      this.data.shortCode1,
      this.data.shortCode2,
      this.data.lang,
      this.data.deliveryChoiceResponse.consigneeInformation.zipCode,
      "RSDNRV",
      this.pickedDate,
      null,
      email).subscribe(
        response => {
          response.forEach(oneMessage => {
            // TODO quand on saura comment traiter les erreurs du WS
            if (oneMessage.id === "0") {
              this.atIternetService.generateClickAction(
                this.data.tag, 
                'confirmer', 
                'popin_modification_confirmation_adresse_reprogrammer_livraison'
              );
              this.choiceConfirmed = true
            }
          }
        )
      }
    );
  }
}

